<div
  class="tag-wrapper"
  [ngClass]="{
    'tag-inactive': disabled,
    'tag-selected': selected,
    'tag-fill': mode === 'fill',
    'tag-outline': mode === 'outline',
    'tag-active': !disabled && !selected,
  }"
  role="button"
  [attr.aria-disabled]="disabled"
  [attr.aria-selected]="selected"
  >
  <div class="tag">
    @if (icon) {
      <hyperkit-icon [icon]="icon" size="small"></hyperkit-icon>
    }
    @if (textLeft) {
      <hyperkit-typography
        class="static-left"
        variant="emphasized"
        size="sm"
        color="inherit"
        >{{ textLeft }}</hyperkit-typography
        >
      }
      <hyperkit-typography
        class="tag-text"
        variant="emphasized"
        size="sm"
        color="inherit"
        >{{ text }}</hyperkit-typography
        >
        @if (operation) {
          <hyperkit-typography
            class="operation"
            variant="emphasized"
            size="sm"
            color="inherit"
            >{{ operation }}</hyperkit-typography
            >
          }
          @if (textRight) {
            <hyperkit-typography
              class="static-right"
              variant="emphasized"
              size="sm"
              color="inherit"
              >{{ textRight }}</hyperkit-typography
              >
            }
            @if (closable) {
              <hyperkit-icon
                (click)="emitOnClose($event)"
                class="close-icon"
                icon="x"
                size="small"
                color="inherit"
                aria-label="Close"
              ></hyperkit-icon>
            }
          </div>
        </div>
